"use client";

import Image from "next/image";
import { usePathname } from "next/navigation";
import { Home, Menu } from "lucide-react";
import { BRAND_NAME, VISIBLE_LOGO_SRC } from "@/lib/brand";
import Link from "next/link";
import { easterNavigationItems } from "@/content/easter-wallpaper-site";

export default function SiteHeader() {
  const pathname = usePathname() || "/";

  const isUtilityPath =
    pathname.startsWith("/my-") ||
    pathname.startsWith("/profile") ||
    pathname.startsWith("/auth") ||
    pathname.startsWith("/admin") ||
    pathname.startsWith("/api-keys");

  if (isUtilityPath) {
    return (
      <header className="fixed left-0 right-0 top-0 z-50 border-b border-[#ddcec0] bg-[#fffaf4]/90 backdrop-blur-xl">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
          <Link href="/" className="flex items-center gap-3">
            <Image
              src={VISIBLE_LOGO_SRC}
              alt={BRAND_NAME}
              width={34}
              height={34}
              sizes="34px"
              className="rounded-xl"
              data-brand-logo="header"
              priority
            />
            <span className="text-lg font-semibold tracking-[-0.02em] text-[#2d3528]">
              {BRAND_NAME}
            </span>
          </Link>

          <Link
            href="/"
            className="inline-flex h-10 items-center justify-center gap-2 rounded-full border border-[#d7c8bc] bg-white/80 px-4 text-sm font-semibold text-[#345141] transition hover:border-[#c7b29f]"
          >
            <Home className="h-4 w-4" />
            Home
          </Link>
        </div>
      </header>
    );
  }

  return (
    <header className="fixed left-0 right-0 top-0 z-50 border-b border-[#ddcec0] bg-[#fffaf4]/88 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Link href="/" className="flex items-center gap-3">
          <Image
            src={VISIBLE_LOGO_SRC}
            alt={BRAND_NAME}
            width={34}
            height={34}
            sizes="34px"
            className="rounded-xl"
            data-brand-logo="header"
            priority
          />
          <div className="flex flex-col">
            <span className="text-lg font-semibold tracking-[-0.02em] text-[#2d3528]">
              {BRAND_NAME}
            </span>
            <span className="hidden text-[10px] uppercase tracking-[0.26em] text-[#977259] sm:block">
              Spring Lantern Edition
            </span>
          </div>
        </Link>

        <nav className="hidden items-center gap-6 md:flex">
          {easterNavigationItems.map((item) => (
            <Link
              key={`${item.title}-${item.href}`}
              href={item.href}
              className="text-sm font-medium text-[#5b6357] transition-colors hover:text-[#2e3529]"
            >
              {item.title}
            </Link>
          ))}
        </nav>

        <Link
          href="/#generate"
          className="hidden h-10 items-center justify-center rounded-full bg-[#2f5c47] px-5 text-sm font-semibold text-white transition hover:bg-[#264b3a] md:inline-flex"
        >
          Generate
        </Link>

        <button
          type="button"
          className="flex h-10 w-10 items-center justify-center rounded-lg text-[#2d3528] md:hidden"
          aria-label="Toggle menu"
        >
          <Menu className="h-5 w-5" />
        </button>
      </div>
    </header>
  );
}
